import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { buildRepoLink, buildRefUrl } from "core/utils";
import "./repo-link.scss";
import { Icon, SemanticICONS } from "semantic-ui-react";
import ProjectForm from "models/forms/project-form";
import Project from "models/project";
import { AuthorizationProvider } from "models/settings";
import { SettingsStore } from "stores";

interface Props {
  project: Project | ProjectForm;
  gitRef?: string;
  hideProvierIcon?: boolean;
  displayText?: string;
  newWindow?: boolean;
}

const providerIcons: { [provider: string]: SemanticICONS } = {
  [AuthorizationProvider.GitHub]: "github",
  [AuthorizationProvider.BitBucket]: "bitbucket",
  [AuthorizationProvider.BitBucketServer]: "bitbucket",
  [AuthorizationProvider.Gitlab]: "gitlab",
  [AuthorizationProvider.Spira]: "server",
};

const ProviderIcon = ({ provider }: { provider: string }) =>
  provider == AuthorizationProvider.AzureDevOps ? (
    <img className="provider-logo" src="/img/integrations/azure-devops.svg" alt="Azure DevOps" />
  ) : (
    <Icon name={providerIcons[provider] || "git"} />
  );

const RepoLink = observer(({ project, gitRef, hideProvierIcon, displayText, newWindow }: Props) => {
  const isAzureDevOps = project?.gitProvider == AuthorizationProvider.AzureDevOps;

  // Azure DevOps links need the organization URL, which only the account's authorization holds.
  useEffect(() => {
    if (isAzureDevOps) SettingsStore.ensureAuthorizations();
  }, [isAzureDevOps]);

  const authorizations = SettingsStore.authorizations;

  return (
    <div className="repo-link">
      {project && project.gitProvider && !hideProvierIcon && <ProviderIcon provider={project.gitProvider} />}
      <a
        onClick={(e) => e.stopPropagation()}
        href={gitRef ? buildRefUrl(project, gitRef, authorizations) : buildRepoLink(project, authorizations)}
        target={newWindow ? "_blank" : null}
      >
        {displayText || (gitRef && gitRef.substring(0, 15)) || project.gitRepo}
      </a>
    </div>
  );
});

export default RepoLink;
